import { render } from "./NotificationSkeleton.vue?vue&type=template&id=f36a04f2&scoped=true"
const script = {}

import "./NotificationSkeleton.vue?vue&type=style&index=0&id=f36a04f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36a04f2"]])

export default __exports__